export enum ReportTypes {
    Revenue = 1,
    Fill = 2,
    InternalFill = 3,
    Requests = 4,
    TopCampaigns = 5,
    UniqueUsers = 6,
    PhonePlanBreakdown = 7
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.enum.ts